import MainLayout from "@/components/layout/MainLayout.vue";
import { required, maxLength, minLength, sameAs } from "vuelidate/lib/validators";
import axios from "axios";
import { mapGetters } from "vuex";
import { fetchNotificationCount } from "@/services/common/notification-service";

export default {
    name: 'changeTeacherPassword',

    components: {
        MainLayout
    },

    data() {
        return {
            teacher: {
                current_password: '',
                new_password: '',
                confirm_new_password: ''
            },
            submitted: false
        };
    },

    validations: {
        teacher: {
            current_password: {
                required,
                minLength: minLength(8),
                maxLength: maxLength(12)
            },
            new_password: {
                required,
                minLength: minLength(8),
                maxLength: maxLength(12)
            },
            confirm_new_password: {
                required,
                sameAsPassword: sameAs("new_password")
            }
        }
    },

    computed: {
        ...mapGetters(["teacherId", "schoolId", "userType"]),
    },
    
    methods: {
        handleSubmit() {
            this.submitted = true;
            if (this.$v.$invalid) {
                return;
            }
            this.changePassword();
        },
        
        changePassword() {
            var request = {
                current_password: this.teacher.current_password,
                new_password: this.teacher.new_password,
                confirm_new_password: this.teacher.confirm_new_password
            };
            axios.post("password/update", request)
                .then((response) => {
                    this.teachers = response.data;
                    this.teacher.current_password = '';
                    this.teacher.new_password = '';
                    this.teacher.confirm_new_password = '';
                    this.submitted = false;
                    if (response.data.status == 1) {
                        this.$notification.success("လုပ်ဆောင်မှု အောင်မြင်ပါသည်။", {
                            timer: 3,
                            position: "bottomCenter"
                        });
                    }
                })
                .catch((error) => {
                    if (error.response.status == '400') {
                        this.$notification.error("လက်ရှိစကားဝှက် မှားယွင်းနေပါသည်။", {
                            timer: 3,
                            position: "bottomCenter"
                        });
                    } else {
                        this.$notification.error("လုပ်ဆောင်မှု မအောင်မြင်ပါ။", {
                            timer: 3,
                            position: "bottomCenter"
                        });
                        console.log("Change Password API Error", error.response.data);    
                    }
                });
        },
    },

    created() {
        fetchNotificationCount();
    }
}
